import React,{useState} from "react";
import { MDBInput } from "mdb-react-ui-kit";


import logo from "../../assets/img/logo.png";
import noperson from "../../assets/img/noperson.svg";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Table,
  Row,
  Col,
  Modal,
  ModalBody
} from "reactstrap";
import axios from "axios";
import { DELETE_USER, VIEW_USER, ROLE_LIST, EDIT_USER,INSERT_USER,UPDATE_USER,BASE_URL_CHAT_WHATSAPP,CLIENT_LIST } from "../../constants";

import NotificationAlert from "react-notification-alert";

import moment from "moment";
import apiService from "../../variables/apiService"

const UserList = () => {

  const navigate = useHistory();
  const drpdwn = [];
  const clientdrpdwn = [];


  const [modalClassic, setModalClassic] = React.useState(false);
  const [singleSelect, setsingleSelect] = React.useState("");
  const [singletypeSelect, setsingleTypeSelect] = React.useState("");
  const [clientSelect, setClientSelect] = React.useState("");
  const [levelSelect, setLevelSelect] = React.useState("");

  const [singleChnlSelect, setsingleChnlSelect] = React.useState("");
  const [isActive, setIsActive] = React.useState(false);
  const [updateUserId, setUpdateUserId] = React.useState(0);
  const notificationAlertRef = React.useRef(null);

  const [isLoading, setIsLoading] = React.useState(true);
  const [countModal, setCountModal] = React.useState(false);
  const [countHistory,setCountHistory] = useState({user:"",history:[],count:0})
  const profileRef = React.useRef(null)
  let lcObj = localStorage.getItem("user");
  let lclStrge = JSON.parse(lcObj);

  const initialState = {
    username: "",
    password: "",
    mobile: "",
    email: "",
    senderId:lclStrge?.sender_id,
    count: 0,
    client:"",
    firstName:"",
    lastName:"",
    profile:noperson
  };

  const toggleModalClassic = () => {
    setModalClassic(!modalClassic);
    setUsers(initialState)
  };
  



  const [users, setUsers] = React.useState(initialState);
  const [status, setStatus] = React.useState("");
  const [usersList, setUsersList] = React.useState([]);
  const [roleList, setRoleList] = React.useState([]);
  const [clientList, setClientList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [alert, setAlert] = React.useState(null);

  const[filterList,setFilterLst] = useState([]);



  const viewUserList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;

    apiService.getData(`${VIEW_USER}?page=${pageNo}&client=${clientid}`).then((response) => {
     
      setUsersList(response.data);
     // setUsersList({...response.data,numOfPages:2});
      setFilterLst(response.data)
      setCurrentPage(pageNo);
      setIsLoading(false)
    })
    .catch((error) => {
      console.log("--err-", error)
      let options={}
        options = {
        place: "tr",
        message: "Unable to Fetch ",
        type: "warning",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
    });

    // axios
    //   .get(`${VIEW_USER}?page=${pageNo}&client=${clientid}`)
    //   .then((response) => {
    //     setUsersList(response.data);
    //    // setUsersList({...response.data,numOfPages:2});
    //     setFilterLst(response.data)
    //     setCurrentPage(pageNo);
    //     setIsLoading(false)
    //   })
    //   .catch((error) => {
    //     console.log("????", error);
    //   });
  };

  React.useEffect(() => {
    viewUserList(1);
    
  }, []);







  const deleteUser = async (id) => {
   apiService.postData(DELETE_USER, { id:  id.toString()})
     .then((res) => {
      let options={}
        options = {
         place: "tr",
         message: "Deleted Successfully",
         type: "success",

         autoDismiss: 2,
       };
       notificationAlertRef.current.notificationAlert(options);
       viewUserList(currentPage);
     setAlert(null)
     })
     .catch((err) => {
      console.log("--err-", err)
      let options={}
        options = {
        place: "tr",
        message: "Unable to Delete ",
        type: "warning",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
     })
    // await axios
    //   .post(DELETE_USER, { id:  id.toString()})
    //   .then((res) => {
    //    const  options = {
    //       place: "tr",
    //       message: "Deleted Successfully",
    //       type: "success",

    //       autoDismiss: 2,
    //     };
    //     notificationAlertRef.current.notificationAlert(options);
    //     viewUserList(currentPage);
    //   setAlert(null)
    //   })
    //   .catch((err) => console.log("--err-", err));
  };

  const confirmdeleteUser = (id) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deleteUser(id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You want to remove user ?
      </ReactBSAlert>
      );
  }

  const filterData = (e) =>{
    let filter = e.target.value;

     let filterdata = filterList?.message.filter((item,index)=>{
      return (item?.username?.toLowerCase()?.includes(filter)
      ||moment(item?.updatedat).format('DD-MM-YYYY').toLowerCase().includes(filter)
      ||item?.role?.toLowerCase().includes(filter)
      ||item?.mobile?.toLowerCase().includes(filter)
      ||item?.email?.toLowerCase().includes(filter)
      ||item?.tuserstatus?.toLowerCase().includes(filter)
      )})
     setUsersList({
      message: filterdata,
      numOfPages:filterList.numOfPages
    })
    // console.log("--221--",a);
    }

    const addCount =()=>{
      alert(countHistory.name)
      alert(countHistory.count)
    }

  return (
    <>
     <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pd-0">
      {alert}
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody className="tableheightwf">
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="mt-4 add-content" onClick={()=>{
                          navigate.push("/admin/user/createUser");
                        }}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"
                        
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </Button>
                      Add User
                    </h4>
                  </Col>
                  {/* <Col md='3' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  
                  </Col> */}
                </Row>
              </Col>
              <Col sm="12" className="">
                <Row>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>User Name</th>
                       
                        <th> Client </th>
                        <th> Mobile </th>
                        <th> Role </th>
                        <th> Status</th>
                        <th> Created At</th>
                        <th> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersList?.message?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{item.username}</td>
                             
                              <td>{item.company_name}</td>
                              <td>{item.mobile}</td>
                              <td>{item.role}</td>
                              {/* <td >
                                {item.usertype == "3" ? (
                                  <Badge color="primary">Postpaid</Badge>
                                ) : (
                                  <>
                                   <Badge color="info">prepaid</Badge>
                                   
                                  <i style={{marginLeft:"10px",cursor:"pointer"}} onClick={()=>{setCountModal(true);setCountHistory({name:item.username})}}  class="tim-icons icon-pencil" ></i>
                                  </>
                                 
                                  
                                )}
                              </td> */}
                              <td>
                                {item.status == 0 && (
                                  <Badge color="success">Active</Badge>
                                )}  {item.status == 1 && (
                                  <Badge color="warning">In-active</Badge>
                                )}
                              </td>
                              <td>
                                {item.createdat
                                  ? moment(item.createdat).format("MMM-DD-YYYY")
                                  : "---"}
                              </td>
                              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    class="tim-icons icon-pencil"
                                    onClick={() =>  navigate.push("/admin/user/createUser",{  id: item.id } )}
                                  ></i>
                                </a>
                                <a
                                  to=""
                                  value={item}
                                  onClick={() =>confirmdeleteUser(item.id)}
                                  //onClick={() =>deleteUser(item.id)}
                                  className="text-warning ml-2"
                                >
                                  <i className="tim-icons icon-trash-simple"></i>
                                </a>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            { usersList?.numOfPages>1&&
        <div style={{padding:"8px",marginLeft:"auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={usersList?.numOfPages}
      onPageChange={(newPage )=>{viewUserList(newPage)}}
    />
    </div>
}
          </Card>

         
          <Modal isOpen={countModal} toggle={()=>setCountModal(false)}>
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={()=>setCountModal(false)}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h3 className="title title-up multicolortext">{countHistory.name} Perpaid List</h3>
            </div>
            <ModalBody className="modelbody ">
              <Row>
              <Col sm="4" className="mb-2">
                  <MDBInput
                    label="Add Count "
                    type="number"
                    name="count"
                    value={countHistory.count}
                    onChange={(e)=>setCountHistory({...countHistory,count:e.target.value})}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary "
                    onClick={()=>addCount()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              <Table responsive stiped style={{height:"200px"}}>
                    <thead>
                      <tr>
                        <th>Sno</th>
                        <th>Count</th>
                        <th> Create Date </th>
                       
                      </tr>
                    </thead>
                    <tbody>
                      {usersList?.message?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{index+1}</td>
                              <td>23</td>
                              <td>04/01/2024</td>
                              
                           
                              
                              {/* <td>
                                {item.createdat
                                  ? moment(item.createdat).format("MMM-DD-YYYY")
                                  : "---"}
                              </td> */}
                             
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  
                    </tbody>
                  </Table>
                
               
              </Row>
            </ModalBody>
          </Modal>
        </Row>
      </div>
    </>
  );
};

export default UserList;
